import React from 'react'
import Hero from './Hero'

function AboutPage() {
    return (
        <>
        <Hero/>
        </>
    )
}

export default AboutPage
